import { TextResources, ConfigData } from '../config/StoreLocatorTextResources';
import { STORELOCATORCOMPONENT } from './storelocator.component';
import { HOURS } from '../services/opening.hours.service';
import { ROUTE } from '../services/route.directions.service';
import { TEMPLATE } from '../templates/cwc-templates';

export class LocationComponent {
  /**
   * Propertys
   */
  locationProducts = [];
  currentLocations: object;
  items = [];

  placeLocations(locationsXML) {
    const xmlDoc = locationsXML.getElementsByTagName('location');
    const locationBody = STORELOCATORCOMPONENT.mapLocationHtmlElement;
    const sidebar = STORELOCATORCOMPONENT.sidebarHtmlElement;
    let locations;

    if (ConfigData.data['singleLocations']) {
      locations = locationBody;
    } else {
      const hasSliderBody = sidebar.querySelector('cwc-sidebar-body');
      locations = hasSliderBody ? hasSliderBody : document.createElement('cwc-sidebar-body');

      sidebar.appendChild(locations);
    }

    locations.innerHTML = '';
    this.items = []; // Reset items to only contain locations from the desired city

    if (xmlDoc.length > 0) {
      let itemsString = '';

      for (let i = 0; i < xmlDoc.length; i++) {
        const locationNode = xmlDoc[i];
        const childObjct = locationNode.children;
        const childObjValues = Object.values(childObjct);
        const prodId = this.getExistingProductsId(locationNode);
        const provider = this.getExistingProvider(locationNode);
        const locationItem = this.prepareLocationObj(childObjValues, prodId, provider);

        if (ConfigData.data['singleLocations']) {
          ROUTE.currenLocationCoords = {
            lat: Number(locationItem['latitude']),
            lng: Number(locationItem['longitude']),
          };
        }

        if (locationItem['distance'] === undefined) {
          locationItem['distance'] = ROUTE.getDistance(locationItem['latitude'], locationItem['longitude']);
        }

        if (TEMPLATE.isNotBlacklisted(ConfigData.data['locationBlacklist'], locationItem['loc_id'])) {
          this.items.push(locationItem);
          itemsString += STORELOCATORCOMPONENT.createTemplate(locationItem, this.locationProducts);
        }
      }
      locations.innerHTML = itemsString;
    }
    return this.items;
  }

  prepareLocationObj(location, productIds, provider) {
    const locationObj = {};
    const productData = this.getProductData();
    const partnerPinJson = this.getPartnerPinJsonElement();
    const partnerLogoJson = this.getJsonContent(partnerPinJson);

    for (const key in location) {
      const itemKey = location[key].nodeName;
      let itemValue = location[key].innerHTML;
      let ceweProvider = false;

      if (itemKey === 'distance') {
        itemValue = parseFloat(itemValue).toFixed(2);
      }

      if (itemKey === 'onsite_printer') {
        locationObj['onsite_prints'] = this.createLocationProductIdsString(location[key]);

        for (let i = 0; i < provider.length; i++) {
          if (provider[i].includes('CEWE')) {
            ceweProvider = true;
          }
        }

        for (let i = 0; i < productIds.length; i++) {
          if (productData.photos.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_photos'] = 'yes';
            locationObj['prod_photos_frame'] = 'yes';
            if (this.locationProducts.indexOf('prod_photos') === -1) {
              this.locationProducts.push('prod_photos');
            }
          }
          if (productData.poster.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_poster'] = 'yes';
            if (this.locationProducts.indexOf('prod_poster') === -1) {
              this.locationProducts.push('prod_poster');
            }
          }
          /*if (productData.photos_frame.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_photos_frame'] = 'yes';
          }*/
          if (productData.photos_strip.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_photos_strip'] = 'yes';
            if (this.locationProducts.indexOf('prod_photos_strip') === -1) {
              this.locationProducts.push('prod_photos_strip');
            }
          }
          if (productData.greeting_cards.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_greeting_cards'] = 'yes';
            if (this.locationProducts.indexOf('prod_greeting_cards') === -1) {
              this.locationProducts.push('prod_greeting_cards');
            }
          }
          if (productData.collages.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_collages'] = 'yes';
            if (this.locationProducts.indexOf('prod_collages') === -1) {
              this.locationProducts.push('prod_collages');
            }
          }
          if (productData.photo_sets.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_photo_sets'] = 'yes';
            if (this.locationProducts.indexOf('prod_photo_sets') === -1) {
              this.locationProducts.push('prod_photo_sets');
            }
          }
          if (productData.multipart_photos.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_multipart_photos'] = 'yes';
            if (this.locationProducts.indexOf('prod_multipart_photos') === -1) {
              this.locationProducts.push('prod_multipart_photos');
            }
          }
          if (productData.stickers.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_stickers'] = 'yes';
            if (this.locationProducts.indexOf('prod_stickers') === -1) {
              this.locationProducts.push('prod_stickers');
            }
          }
          if (productData.product_labels.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_product_labels'] = 'yes';
            if (this.locationProducts.indexOf('prod_product_labels') === -1) {
              this.locationProducts.push('prod_product_labels');
            }
          }
          if (productData.canvas.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_canvas'] = 'yes';
            if (this.locationProducts.indexOf('prod_canvas') === -1) {
              this.locationProducts.push('prod_canvas');
            }
          }
          if (productData.retro_minis.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_retro_minis'] = 'yes';
            if (this.locationProducts.indexOf('prod_retro_minis') === -1) {
              this.locationProducts.push('prod_retro_minis');
            }
          }
          if (ceweProvider && productData.passfoto.productid.indexOf(Number(productIds[i])) > -1) {
            locationObj['prod_passfoto'] = 'yes';
            if (this.locationProducts.indexOf('prod_passfoto') === -1) {
              this.locationProducts.push('prod_passfoto');
            }
          }
        }
      } else {
        locationObj[itemKey] = itemValue;
      }

      const filename = this.getIconUrl(locationObj['keyacc_id'] || this.getKeyAccount(), partnerLogoJson);
      locationObj['icon_url'] = filename;

      if (itemKey === 'opening_hours') {
        const searchPattern = locationObj['opening_hours'].match(HOURS.searchPattern);

        if (searchPattern !== null) {
          locationObj['opening_hours'] = HOURS.getOpeningHours(locationObj['opening_hours']);
        } else {
          delete locationObj['opening_hours'];
        }
      }
    }
    return locationObj;
  }

  getLocationNode(responseXML) {
    //return responseXML.querySelector('locationlist > content > location');
    return responseXML.querySelector('locationlist > content');
  }

  getProductData() {
    return TextResources.resources['productData'];
  }

  getLocationViewJsonElement() {
    return document.querySelector('cwc-location-view');
  }

  getPartnerPinJsonElement() {
    return document.querySelector('cwc-partner-pin');
  }

  getJsonContent(jsonElement) {
    const jsonContent = jsonElement ? JSON.parse(jsonElement.getAttributeNode('json').value) : false;

    return jsonContent;
  }

  getKeyAccount() {
    return ConfigData.data['keyaccount'];
  }

  getExistingProductsId(locationsXML) {
    const locationProductsid = [];
    const conditionNode = locationsXML.getElementsByTagName('condition');

    for (let i = 0; i < conditionNode.length; i++) {
      locationProductsid.push(conditionNode[i].getAttribute('art_id'));
    }

    return locationProductsid;
  }

  getExistingProvider(locationsXML) {
    const locationProvider = [];
    const conditionNode = locationsXML.getElementsByTagName('provider');

    for (let i = 0; i < conditionNode.length; i++) {
      locationProvider.push(conditionNode[i].getAttribute('name'));
    }

    return locationProvider;
  }

  createLocationProductIdsString(onsitePrinterNode) {
    let products: string = '';
    let countItem: number = 0;
    const photoIds: number[] = TextResources.resources['productData'].photos.productid;
    const posterIds: number[] = TextResources.resources['productData'].poster.productid;
    const onsitePrintsIds: number[] = photoIds.concat(posterIds);
    const conditionNodeArray: Element[] = Array.from(onsitePrinterNode.querySelectorAll('condition'));

    conditionNodeArray.map((item) => {
      const artId = Number(item.attributes[0].nodeValue);
      const separator = countItem !== 0 ? ',' : '';
      const hasArtId = onsitePrintsIds.includes(artId);

      if (hasArtId) {
        products += `${separator + artId}`;
        countItem = countItem + 1;
      }
    });

    return products;
  }

  getCurrentLocationData(locationId) {
    const currentLocations = this.currentLocations;

    for (const i in currentLocations) {
      if (currentLocations[i]['loc_id'] === locationId) {
        return currentLocations[i];
      }
    }
  }

  /**
   * If the partnerLogoJson object is not empty, the URL is taken from the object,
   * otherwise from the text resources
   */
  getIconUrl(content_keyaccount: string, partnerLogoJson: object) {
    let filename = '';
    let filenameValue = '';

    if (filename.length === 0) {
      for (const key in partnerLogoJson) {
        if (content_keyaccount === key) {
          filenameValue = partnerLogoJson[key];
        }
      }
    }
    filename = filenameValue !== '' ? filenameValue : TextResources.resources['location'].default_pin;

    return filename;
  }
}

export const LOCATIONCOMPONENT = new LocationComponent();
